<template>
    <v-tab-item
        v-if="superUser || permission"
        :value="$route.fullPath"
        class="pa-3"
    >
        <v-row
            no-gutters
            justify="space-between"
            align="center"
            class="px-4 pb-6"
        >
            <v-btn
                :disabled="!getPermission('settinsg.users.create')"
                color="secondary"
                class="text-capitalize ml-3 ml-sm-0"
                depressed
                v-text="translations.registerUser[lang]"
                @click="open('create', {})"
            ></v-btn>

            <v-col cols="12" sm="4" class="pa-0">
                <b-search-field></b-search-field>
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="users"
            :footer-props="{
                itemsPerPageOptions: [12],
                showCurrentPage: true,
                pageText: `${page * 12 - 11}-${
                    page * 12 <= serverItemsLength
                        ? page * 12
                        : serverItemsLength
                } ${translations.paginationText[lang]} ${serverItemsLength}`,
            }"
            :page.sync="page"
            :server-items-length="serverItemsLength"
            :loading="loading"
            disable-sort
            class="b-outlined"
        >
            <template v-slot:item.permissions_enabled="{ item }">
                <span
                    v-if="item.permissions_enabled"
                    class="green--text"
                    v-text="translations.yes[lang]"
                ></span>
                <span
                    v-else
                    class="red--text"
                    v-text="translations.no[lang]"
                ></span>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-tooltip color="secondary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                        :disabled="!getPermission('settinsg.users.read')"
                            icon
                            v-on="on"
                            @click="
                                () => {
                                    userId = item.user_id;
                                    profileDialog = true;
                                }
                            "
                        >
                            <v-icon
                                v-text="icons.mdiAccountSearchOutline"
                            ></v-icon>
                        </v-btn>
                    </template>

                    <span
                        class="font-weight-bold"
                        v-text="translations.userProfile[lang]"
                    ></span>
                </v-tooltip>

                <v-tooltip color="secondary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            :disabled="!getPermission('settinsg.users.update')"
                            color="yellow darken-3"
                            icon
                            v-on="on"
                            @click="open('update', item)"
                        >
                            <v-icon v-text="icons.mdiPencilOutline"></v-icon>
                        </v-btn>
                    </template>

                    <span
                        class="font-weight-bold"
                        v-text="translations.updatePermissions[lang]"
                    ></span>
                </v-tooltip>
                <v-tooltip v-if="showUpgrade" color="secondary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                :disabled="!getPermission('settinsg.users.update')"
                                color="secondary"
                                icon
                                v-on="on"
                                @click="() => {open('upgrade',item)}"
                            >
                                <v-icon
                                    v-text="icons.mdiChevronDoubleUp"
                                ></v-icon>
                            </v-btn>
                        </template>
                        <span
                            class="font-weight-bold"
                            v-text="translations.upgrade[lang]"
                        ></span>
                    </v-tooltip>
                    <v-tooltip v-if="superUser && userIsManager(item)" color="secondary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                :disabled="!getPermission('settinsg.users.update')"
                                color="secondary"
                                icon
                                v-on="on"
                                @click="() => {open('downgrade',item)}"
                            >
                                <v-icon
                                    v-text="icons.mdiChevronDoubleDown"
                                ></v-icon>
                            </v-btn>
                        </template>
                        <span
                            class="font-weight-bold"
                            v-text="translations.downgrade[lang]"
                        ></span>
                    </v-tooltip>
                    <v-tooltip v-if="superUser || (loggedManager && !userIsManager(item))" color="secondary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                            :disabled="!getPermission('settinsg.users.delete')"
                            color="red darken-1"
                            icon
                            v-on="on"
                            @click="() => {open('delete',item)}"
                        >
                            <v-icon v-text="icons.mdiClose"></v-icon>
                        </v-btn>
                        </template>
                        <span
                            class="font-weight-bold"
                            v-text="translations.delete[lang]"
                        ></span>
                    </v-tooltip>
            </template>
        </v-data-table>
        <!-- <v-dialog v-model="dialog" max-width="500">
            <UserForm :mode="mode" @cancel="dialog = false" />
        </v-dialog> -->

        <v-dialog v-model="profileDialog" max-width="500">
            <UserProfile :user-id="userId" @cancel="profileDialog = false" />
        </v-dialog>
        
        <v-dialog v-model="dialog" max-width="600">
                <UserForm v-if="['create', 'update'].includes(mode)" :mode="mode" @cancel="dialog = false" />
                <b-card
                    v-else-if="mode"
                :type="mode"
                :title="`${translations[mode][lang]} ${translations.user2[lang]}`"
                :submit-text="translations[mode]"
                :loading="loading"
                :error-message="errorMessage"
                @cancel="closeDialog()"
                @submit="submitDialog()"
            >
                <div class="subtitle-1 font-weight-medium pt-2 px-2">
                    {{ translations.confirmationMessageSure[lang] }}
                    <span v-html="translations[`${mode}ConfirmationMessage`][lang]"></span>
                    <span class="font-weight-bold text--primary">{{
                        userData.user
                    }}</span
                    ><span v-if="['upgrade', 'downgrade'].includes(mode)" class="ml-1" v-html="translations[`${mode}To`][lang]"></span>{{ translations.questionmark[lang] }}
                </div>
            </b-card>
            </v-dialog>
    </v-tab-item>
</template>

<script>
import users from "@/store/modules/storePanel/settings/users";

import {
    mdiCheckboxBlankOutline,
    mdiCheckBoxOutline,
    mdiCheckCircleOutline,
    mdiMinusCircleOutline,
    mdiAccountSearchOutline,
    mdiPencilOutline,
    mdiChevronDoubleUp,
    mdiChevronDoubleDown,
    mdiClose
} from "@mdi/js";


import { mapState, mapMutations, mapActions } from "vuex";
import UserForm from "@/components/storePanel/settings/users/UserForm.vue";
import UserProfile from "@/components/storePanel/settings/users/UserProfile.vue";

import translations from "@/utils/translations/storePanel/settings/users";
import { cloneDeep } from "lodash";

export default {
    name: "Users",

    components: { UserForm, UserProfile },

    mixins: [translations],

    data() {
        return {
            icons: {
                mdiCheckboxBlankOutline,
                mdiCheckBoxOutline,
                mdiCheckCircleOutline,
                mdiMinusCircleOutline,
                mdiAccountSearchOutline,
                mdiPencilOutline,
                mdiChevronDoubleUp,
                mdiChevronDoubleDown,
                mdiClose
            },
            page: +this.$route.query.page,
            mode: '',
            userId: null,
            profileDialog: false,
            userData: {}
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "serverItemsLength",
            "superUser",
            "store"
        ]),
        ...mapState("storePanel/settings/users", ["moderatorPermissions", "users"]),

        lang() {
            return this.$route.params.lang;
        },

        permission() {
            return this.$store.state.permissions.settings
                ? this.$store.state.permissions.settings.users.read
                : this.superUser;
        },

        showUpgrade() {
            if (!this.users?.length) {
                return false
            }
            for(let user of this.users){
                if(this.userIsManager(user)){
                    return false
                }
            }
            return this.superUser
        },

        loggedManager() {
            if (!this.users?.length) {
                return false
            }
            for(let user of this.users){
                if(user.user_account_id == this.loggedUser?.user_account_id){
                    return this.userIsManager(user)
                }
            }
            return false
        },

        loggedUser: {
            get() {
                return this.$store.state.user;
            }
        },

        headers() {
            return [
                { text: this.translations.user[this.lang], value: "user" },
                { text: this.translations.role[this.lang], value: "role" },
                {
                    text: this.translations.date[this.lang],
                    value: "created_at",
                },
                {
                    text: this.translations.enabled[this.lang],
                    value: "permissions_enabled",
                },
                {
                    text: this.translations.actions[this.lang],
                    value: "actions",
                },
            ];
        },
        

        dialog: {
            get() {
                return this.$store.state.dialog;
            },

            set(val) {
                this.setDialog(val);
            },
        },

        user: {
            get() {
                return this.$store.state.storePanel.users.user;
            },

            set(val) {
                this.setItem(val);
            },
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
    },

    methods: {
        ...mapMutations([
            "setDialog",
            "setResetSuccess",
            "setResetValidation"
        ]),
        ...mapMutations("storePanel/settings/users", ["setItem"]),
        ...mapActions("storePanel/settings/users", [
            "getModeratorPermissions",
            "getItems",
            "create", "update", "upgrade", "downgrade", "delete"
        ]),
        ...mapActions(["getPermission"]),

        open(mode, item) {
            this.mode = mode;
            item.country_id = item.country_id || this.store?.country?.country_id;
            if (mode === 'create') {
                item.permissions = cloneDeep(this.moderatorPermissions);
            } 
            this.setItem(item);
            this.userData = item
            setTimeout(() => this.setResetSuccess(true), 300);
            this.setResetValidation(true);
            this.dialog = true;
        },

        userIsManager(user){
            return user.role.match(/manager/i)?.length > 0
        },

        closeDialog(){
            this.user = {}
            this.userData = {}
            this.mode = ''
            this.dialog = false
        },

        async submitDialog(){
            if (typeof this[this.mode]  == 'function') {
                await this[this.mode](this.userData)
                await this.getItems(this.query)
            }
        },
    },

    watch: {
        permission: {
            immediate: true,
            handler(val) {
                if (!val && !this.superUser) {
                    this.$router.replace(
                        `/${this.lang}/storePanel/forbidden-gateway`
                    );
                }
            },
        },

        $route(val) {
            if (!val.query.page) {
                this.$router.replace({
                    query: {
                        page: 1,
                        ...this.$route.query,
                    },
                });
            }
            this.getItems(this.query);
        },

        page(page) {
            this.$router.replace({ query: { ...this.$route.query, page } });
        },
    },

    beforeCreate() {
        if (!this.$store.state.storePanel.users) {
            this.$store.registerModule(["storePanel", "users"], users);
        }

        if (!this.$route.query.page) {
            this.$router.replace({
                query: {
                    page: 1,
                    ...this.$route.query,
                },
            });
        }
    },

    mounted() {
        this.getItems(this.query);
        this.getModeratorPermissions();
    },
};
</script>
